<template>
  <div id="app">

    <alfresco server-address="" v-model="alfSession" @message="sessionError"></alfresco>

    <pre>{{ messages }}</pre>

    <dropzone id="myVueDropzone" :url="alfSession.uploadUrl" @vdropzone-success="showSuccess" @vdropzone-sending="sending">
        <input type="hidden" name="token" value="xxx">
    </dropzone>

  </div>
</template>

<script>
import Dropzone from 'vue2-dropzone'
import Alfresco from '@/components/alfresco'

export default {
  name: 'app',
  components: {
    Dropzone, Alfresco
  },
  data () {
    return {
      messages: "",
      alfSession: { uploadUrl:"http://localhost"}
    }
  },
  methods: {
    showSuccess (file) {
      console.log('A file was successfully uploaded')
    },
    sending(file, xhr, formData) {
      formData.append("title", "Test3.jpg");
      formData.append("year", "2017");
      formData.append("folder", "345ea9db-4ffa-4ced-81ed-1484c9f6ff8b");
      console.log(formData);
    },
    sessionError(e) {
      this.messages += e + "\n";
    }
  }
}
</script>

<style>
pre {
  padding: 1em;
  border: 1px silver solid;
  background-color: #eee;
}
</style>



// WEBPACK FOOTER //
// App.vue?48caafce